import { Injectable } from '@angular/core';
import { DecimalPartPipe, IntegerPartPipe } from '@dch/ng-common-components';
import { LanguageService } from '@dch/ng-common';

@Injectable()
export class FormatPositiveAmountService {
  constructor(
    private languageService: LanguageService,
    private integerPartPipe: IntegerPartPipe,
    private decimalPartPipe: DecimalPartPipe
  ) {}

  getFormattedPositiveAmountWithCurrencyAndDecimal(amount: string) {
    const currencySpace =
      this.languageService.getSelectedLanguage() === 'en' ? '' : ' ';
    const decimalPart = this.decimalPartPipe.transform(amount);
    const integerPart = this.integerPartPipe.transform(amount);
    return '€' + currencySpace + integerPart + decimalPart;
  }
}
